import React from 'react';
import TerminalPortfolio from './TerminalPortfolio';

function App() {
  return (
    <div className="App">
      <TerminalPortfolio />
    </div>
  );
}
<h1 className="text-4xl font-bold text-blue-500">
  Tailwind is working!
</h1>

export default App;